import React from 'react';
import { Role } from '../types/commission';
import { bonusLabel, formatCurrency, stepPayoutLabel, stepRangeLabel } from '../utils/commission';
interface CommissionScheduleProps {
  role: Role;
  activeStepIndex: number;
}
export function CommissionSchedule({
  role,
  activeStepIndex
}: CommissionScheduleProps) {
  const isBps = role.model === 'bps';
  return <section aria-labelledby="schedule-heading" className="rounded-xl border border-slate-200 bg-white p-6 shadow-card" data-id="element-1" data-mp="a805d3806gtx">
      <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-2" data-mp="1218y8bg9glrm">
        <h2 id="schedule-heading" className="text-base font-bold text-slate-900" data-id="element-3" data-mp="11z69rvurb0p0">
          {role.name} commission schedule
        </h2>
        <p className="text-sm text-slate-500" data-id="element-4" data-mp="t140yu4s73r6">
          {isBps ? `${role.baseBps} BPS base · paid per funded loan` : `Flat incentive per ${role.incentiveNoun}`}
        </p>
      </div>

      <div className="mt-5 overflow-x-auto" data-id="element-5" data-mp="3dq0g2q4y10b8">
        <table className="w-full min-w-[520px] text-sm" data-id="element-6" data-mp="3doyuhrqawvf9">
          <caption className="sr-only" data-id="element-7" data-mp="2omc3b1h8sfje">Commission schedule for the {role.name} plan</caption>
          <thead data-id="element-8" data-mp="2tmgjeqe8n893">
            <tr className="border-b border-slate-200 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-9" data-mp="2tkvogzo0hnap">
              <th scope="col" className="py-2 pr-4 text-left" data-id="element-10" data-mp="2fldxcdn8txy6">
                Monthly {role.scope.toLowerCase()} {role.unitNounPlural}
              </th>
              <th scope="col" className="px-4 py-2 text-right" data-id="element-11" data-mp="25wm5s6m3hfns">
                {isBps ? 'Additional' : 'Incentive'}
              </th>
              <th scope="col" className="px-4 py-2 text-right" data-id="element-12" data-mp="2anuibbiq1h56">
                {isBps ? 'Total' : 'Per ' + (role.incentiveNoun ?? 'unit')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-13" data-mp="20yavxvvsv55k">
            {role.steps.map((step, index) => {
            const isActive = index === activeStepIndex;
            return <tr key={step.minUnits} className={isActive ? 'bg-brand-50' : undefined} data-id="element-14" data-mp="1rwuo9vwddh51" data-mpi={index}>
                  <th scope="row" className="py-3 pr-4 text-left font-semibold text-slate-900" data-id="element-15" data-mp="3tmabefjej0dm">
                    <span className="flex items-center gap-2" data-id="element-16" data-mp="3ouifdphh82g3">
                      {stepRangeLabel(step, role.unitNounPlural)}
                      {isActive ? <span className="rounded-full bg-brand-700 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-17" data-mp="3kr2kaxl22a5i">
                          Current
                        </span> : null}
                    </span>
                  </th>
                  <td className="px-4 py-3 text-right tabular-nums text-slate-700" data-id="element-18" data-mp="ceeshwvfxyjn">{bonusLabel(role, step)}</td>
                  <td className={`px-4 py-3 text-right tabular-nums ${isActive ? 'font-bold text-slate-900' : 'font-semibold text-slate-700'}`} data-id="element-19" data-mp="7gn0l2usqcfg">
                    {stepPayoutLabel(role, step)}
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>

      {role.monthlyCap ? <p className="mt-4 text-sm font-semibold text-slate-600" data-id="element-20" data-mp="2i0kzawns9rhz">
          Maximum monthly commission: {formatCurrency(role.monthlyCap)}
        </p> : null}
      {role.requiresScorecard ? <p className="mt-2 text-sm text-slate-500" data-id="element-21" data-mp="2rqdzz2me0m7g">
          Unit bonus applies only when the monthly scorecard goal is met — otherwise the base rate is paid.
        </p> : null}
    </section>;
}